import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=55b84c42&scoped=true&"
var script = {}
import style0 from "./Spinner.vue?vue&type=style&index=0&id=55b84c42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b84c42",
  null
  
)

export default component.exports